import _ from "lodash";
import { action, computed, decorate, observable } from "mobx";

class IssueDialogStore {
  constructor(sportyApi) {
    this.sportyApi = sportyApi;
  }

  defaults = {
    checkboxes: [
      {
        isChecked: false,
        value: "TOO_SHORT_OR_LONG",
        label: "Play is too short or too long"
      },
      {
        isChecked: false,
        value: "BAD_SEARCH_RESULT",
        label: "Search result seems wrong"
      },
      {
        isChecked: false,
        value: "POOR_VIDEO_QUALITY",
        label: "Poor video quality"
      }
    ],
    gamePk: 0,
    emptyString: ""
  };
  isOpen = false;
  checkboxes = this.defaults.checkboxes;
  feedType = this.defaults.emptyString;
  gamePk = this.defaults.gamePk;
  playId = this.defaults.emptyString;
  query = this.defaults.emptyString;
  comment = this.defaults.emptyString;

  clear() {
    this.isOpen = false;
    this.resetProperties();
  }

  open({ feedType, gamePk, playId, query }) {
    this.feedType = feedType;
    this.gamePk = gamePk;
    this.playId = playId;
    this.query = query;
    this.isOpen = true;
  }

  resetProperties() {
    this.checkboxes = this.defaults.checkboxes;
    this.feedType = this.defaults.emptyString;
    this.gamePk = this.defaults.gamePk;
    this.playId = this.defaults.emptyString;
    this.query = this.defaults.emptyString;
    this.comment = this.defaults.emptyString;
  }

  get issueTypes() {
    return _.map(
      _.filter(this.checkboxes, c => c.isChecked === true),
      c => c.value
    );
  }

  get issue() {
    return {
      comment: this.comment,
      feedType: this.feedType,
      gamePk: this.gamePk,
      playId: this.playId,
      query: this.query,
      issueTypes: this.issueTypes,
      status: "NEEDS_ATTENTION"
    };
  }

  submit() {
    this.sportyApi.saveIssue(this.issue).then(r => this.clear());
  }
}

decorate(IssueDialogStore, {
  checkboxes: observable,
  isOpen: observable,
  comment: observable,
  clear: action,
  open: action,
  resetProperties: action,
  issue: computed,
  issueTypes: computed
});

export default IssueDialogStore;



// WEBPACK FOOTER //
// ./src/stores/IssueDialogStore.js